import { IReactionDisposer, reaction } from "mobx";
import ImportacaoProcessosStore from "../store/ImportacaoProcessosStore";
import ProcessoStore from "../store/ProcessoStore";
import ImportacaoService from "./ImportacaoService";
import ProcessoService from "./ProcessoService";

class ImportacaoServiceReaction {
    disposer?: IReactionDisposer;

    iniciarReaction() {
        this.disposer?.();
        this.disposer = reaction(() => ImportacaoProcessosStore.processosImportados.length, async (tamanho, tamanhoAnterior = 0) => {
            const processosImportados = ImportacaoProcessosStore.processosImportados.slice(tamanhoAnterior, tamanho);

            processosImportados.forEach(processoImportado => {
                if (!processoImportado) {
                    return;
                }
    
                if (processoImportado.erro) {
                    console.info('não buscar processo com erro');
                    ImportacaoService.finalizarEvtImportacao();
                    return;
                }
    
                ImportacaoService.verificaProcessoNoEscaninhoEAdd(processoImportado);
                return;
            });
            
        });
    }

}

export default new ImportacaoServiceReaction();
